var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIconWithPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 71,
    viewBox: "0 0 60 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8095_221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6095 25.1738V20.8393C50.6095 9.33005 41.2795 0 29.7702 0C18.261 0 8.93108 9.33005 8.93108 20.8391V25.1736C3.45577 27.9678 0.00669831 33.5931 0 39.7402V54.6254C0.00990792 63.6642 7.33479 70.9893 16.3736 70.999H43.1668C52.2057 70.9891 59.5307 63.6642 59.5405 54.6254V39.7404C59.5339 33.5933 56.0848 27.9678 50.6095 25.1738ZM29.7702 8.93108C36.3469 8.93108 41.6783 14.2625 41.6783 20.8391V23.3666H17.8622V20.8391C17.8622 14.2625 23.1936 8.93108 29.7702 8.93108ZM50.6095 54.6254C50.6095 58.7358 47.2774 62.0679 43.167 62.0679H16.3737C12.2634 62.0679 8.93122 58.7358 8.93122 54.6254V39.7404C8.93122 35.63 12.2634 32.2979 16.3737 32.2979H43.167C47.2774 32.2979 50.6095 35.63 50.6095 39.7404V54.6254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2859 41.2305H31.2628C33.7291 41.2305 35.7284 43.2298 35.7284 45.696C35.7284 48.1622 33.7291 50.1615 31.2628 50.1615H28.2859C25.8196 50.1615 23.8203 48.1622 23.8203 45.696C23.8203 43.2298 25.8196 41.2305 28.2859 41.2305Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8095_221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 71,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIconWithPoint);
export default __webpack_public_path__ + "static/media/lock-icon-with-point.e55c54598cf5b4ba83880e9d9666714e.svg";
export { ForwardRef as ReactComponent };